import { CardBrand, CartPaymentCardType } from '@fhs-legacy/frontend/src/generated/graphql-gateway';

// Detect card brand from card number using number patterns
export function detectCardBrand(cardNumber: string): CartPaymentCardType {
  const cleanNumber = cardNumber.replace(/\s/g, '');

  if (cleanNumber.startsWith('4')) {
    return CartPaymentCardType.VISA;
  }
  if (/^5[1-5]/.test(cleanNumber) || /^2[2-7]/.test(cleanNumber)) {
    return CartPaymentCardType.MASTERCARD;
  }
  if (/^3[47]/.test(cleanNumber)) {
    return CartPaymentCardType.AMEX;
  }
  // Discover: 6011/65xx (legacy) and 62 (16-digit) per workspace/frontend parity
  if (/^6(?:011|5)/.test(cleanNumber) || /^62[0-9]{14}$/.test(cleanNumber)) {
    return CartPaymentCardType.DISCOVER;
  }

  return CartPaymentCardType.CREDIT;
}

// Map saved card's CardBrand to CartPaymentCardType duplicate enums on backend
export function mapCardBrandToCartPaymentCardType(cardBrand: CardBrand): CartPaymentCardType {
  const brandString = cardBrand.toString().toUpperCase();
  // CardBrand values like 'VISA', 'MASTERCARD', 'AMEX', etc match CartPaymentCardType enum
  return (
    CartPaymentCardType[brandString as keyof typeof CartPaymentCardType] ||
    CartPaymentCardType.CREDIT
  );
}

/**
 * Normalize payment type string from Apple Pay / Google Pay to CartPaymentCardType.
 * Apple/Google can return "American Express", "AMERICAN EXPRESS", "amex", "AmEx", etc.
 * Legacy commit expects creditType = AMEX for Amex; wrong string yields CREDIT and can break commit/vault.
 */
export function normalizePaymentTypeToCartPaymentCardType(
  paymentType: string
): CartPaymentCardType {
  if (!paymentType || typeof paymentType !== 'string') {
    return CartPaymentCardType.CREDIT;
  }
  const upper = paymentType.toUpperCase().trim();
  const noSpaces = upper.replace(/\s+/g, '');
  // American Express variants (Apple can return "American Express" or "AMEX")
  if (upper === 'AMERICAN EXPRESS' || upper === 'AMEX' || noSpaces === 'AMERICANEXPRESS') {
    return CartPaymentCardType.AMEX;
  }
  const direct = CartPaymentCardType[upper as keyof typeof CartPaymentCardType];
  return direct ?? CartPaymentCardType.CREDIT;
}
